.x{width:100%;}